<template>
  <div>
    <Navbar/>
    <h4></h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idTarifario" class="form-label">IdTarifario</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idTarifario" name="idTarifario" v-model="datoTarifario.idTarifario" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idClasElem" class="form-label"> Clas Elem</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idClasElem" name="idClasElem" v-model="datoTarifario.idClasElem">
                      <option v-for="clasElem in clasElems" :value="clasElem.idClasElem" :key="clasElem.idClasElem">
                        {{ clasElem.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="descripcion" class="form-label">Descripcion</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="descripcion" name="descripcion" v-model="datoTarifario.descripcion" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaDesde" class="form-label">FechaDesde</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaDesde" name="fechaDesde" v-model="datoTarifario.fechaDesde" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaHasta" class="form-label">FechaHasta</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaHasta" name="fechaHasta" v-model="datoTarifario.fechaHasta" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idAsegurador" class="form-label"> Asegurador</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idAsegurador" name="idAsegurador" v-model="datoTarifario.idAsegurador">
                      <option v-for="asegurador in aseguradors" :value="asegurador.idAsegurador" :key="asegurador.idAsegurador">
                        {{ asegurador.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarTarifario" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditTarifario" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdTarifaAseg</th>
          <th scope="col">IdTarifario</th>
          <th scope="col">IdAsegurador</th>
          <th scope="col">FechaReg</th>
          <th scope="col">Estado</th>
          <th scope="col">TarifarioDescripcion</th>
          <th scope="col">AseguradorNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="tarifaaseg in datosPaginados" :key="tarifaaseg.idTarifaAseg">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(tarifaaseg.idTarifaAseg)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(tarifaaseg.idTarifaAseg)" title="Editar">edit_square</i></td>
          <td>{{tarifaaseg.idTarifaAseg}}</td>
          <td>{{tarifaaseg.idTarifario}}</td>
          <td>{{tarifaaseg.idAsegurador}}</td>
          <td>{{getFormattedDate(tarifaaseg.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{tarifaaseg.estado}}</td>
          <td>{{tarifaaseg.tarifarioDescripcion}}</td>
          <td>{{tarifaaseg.aseguradorNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteTarifario(tarifaaseg.idTarifaAseg)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idTarifaAseg" class="form-label">IdTarifaAseg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idTarifaAseg" name="idTarifaAseg" v-model="datoTarifaAseg.idTarifaAseg" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idTarifario" class="form-label">IdTarifario</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idTarifario" name="idTarifario" v-model="datoTarifaAseg.idTarifario" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idAsegurador" class="form-label"> Asegurador</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idAsegurador" name="idAsegurador" v-model="datoTarifaAseg.idAsegurador">
                      <option v-for="asegurador in aseguradors" :value="asegurador.idAsegurador" :key="asegurador.idAsegurador">
                        {{ asegurador.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoTarifaAseg.fechaReg" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarTarifaAseg" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditTarifaAseg" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Navbar from '../../components/Navbar.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js';
import dateFormat from '../../modules/dateFormat.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Navbar, Footer
  },
  data () {
    return {
// Variables master
      tarifarios : [],
      datoTarifario : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idTarifario: '',
      clasElems : [],
      aseguradors : [],
// Variables master
// Variables details
      tarifaasegs : [],
      datoTarifaAseg : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idTarifario = this.$route.params.p_idtarifario
    this.abrirEditar(this.p_idTarifario)
    this.getDataPagina(this.paginaActual)
    this.fetchClasElems()
    this.fetchAseguradors()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'idClasElem'
        ,'descripcion'
        ,'fechaDesde'
        ,'fechaHasta'
        ,'idAsegurador'
      ];
      const requiredFieldsText = [
        'idClasElem'
        ,'descripcion'
        ,'fechaDesde'
        ,'fechaHasta'
        ,'idAsegurador'
      ];
      return validarForm(this.datoTarifario, requiredFields, requiredFieldsText);
    },
    async guardarTarifario(){
      if(this.validarForm() === 1){
        try {
          await api.post('/tarifarios', this.datoTarifario)
          swal("Correcto!", "Tarifario creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditTarifario(){
      if(this.validarForm() === 1){
        try {
          await api.post('/tarifarios', this.datoTarifario)
          swal("Correcto!", "Tarifario creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoTarifario={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idTarifario){
      this.modalWindow = true
      if(idTarifario != null){    
           api.get('/vwtarifarios/'+idTarifario).then(resp=>{
          this.datoTarifario = resp.data;
           });
      }
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarTarifario(){
      this.$router.push('/Tarifario')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.tarifaasegs.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwtarifaasegs/nombre/'+this.nombreBusqueda).then(response=>{
          this.tarifaasegs=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.tarifaasegs.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwtarifaasegs').then(response=>{
      this.tarifaasegs=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.tarifaasegs.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'idClasElem'
        ,'descripcion'
        ,'fechaDesde'
        ,'fechaHasta'
        ,'idAsegurador'
      ];
      const requiredFieldsText = [
        'idClasElem'
        ,'descripcion'
        ,'fechaDesde'
        ,'fechaHasta'
        ,'idAsegurador'
      ];
      return validarForm(this.datoTarifario, requiredFields, requiredFieldsText);
    },
    async guardarTarifaAseg(){
      if(this.validarForm() === 1){
        try {
          this.datoTarifaAseg.idTarifario = this.datoTarifario.idTarifario;
          await api.post('/tarifaasegs', this.datoTarifaAseg)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "TarifaAseg creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditTarifaAseg(){
      if(this.validarForm() === 1){
        try {
          await api.post('/tarifaasegs', this.datoTarifaAseg)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "TarifaAseg creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoTarifaAseg={}
      this.titulo   = 'Crear '
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idTarifaAseg){
      this.modalWindow = true
      if(idTarifaAseg != null){    
           api.get('/vwtarifaasegs/'+idTarifaAseg).then(resp=>{
          this.datoTarifaAseg = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idTarifaAseg){
      this.modalWindow = true
      if(idTarifaAseg != null){
        this.$router.push('/tarifaasegmd/'+idTarifaAseg)
      }
    },
    async deleteTarifaAseg (idTarifaAseg) {
      try{
        await api.delete('/tarifaasegs/'+idTarifaAseg)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchClasElems() {
      fetch('http://localhost:8080/api/v1/claselems')
        .then(response => response.json())
        .then(data => {
          this.clasElems = data;
        })
        .catch(error => {
          console.error('Error fetching clasElems:', error);
        });
    },
    fetchAseguradors() {
      fetch('http://localhost:8080/api/v1/aseguradors')
        .then(response => response.json())
        .then(data => {
          this.aseguradors = data;
        })
        .catch(error => {
          console.error('Error fetching aseguradors:', error);
        });
    },
    fetchTarifarios() {
      fetch('http://localhost:8080/api/v1/tarifarios')
        .then(response => response.json())
        .then(data => {
          this.tarifarios = data;
        })
        .catch(error => {
          console.error('Error fetching tarifarios:', error);
        });
    },
  },
}
</script>
